import { c as _c } from "react/compiler-runtime";
import { CollectedCollectionType } from "@/entities/IProfile";
import CommonSelect, { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import { COLLECTED_COLLECTIONS_META } from "./user-page-collected-filters.helpers";
type SelectedType = CollectedCollectionType | null;
export default function UserPageCollectedFiltersCollection(t0) {
  const $ = _c(4);
  const {
    selected,
    setSelected
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "All",
      mobileLabel: "All Collections",
      value: null,
      key: "all"
    }, ...Object.values(CollectedCollectionType).map(_temp)];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const items = t1;
  let t2;
  if ($[1] !== selected || $[2] !== setSelected) {
    t2 = <CommonSelect items={items} activeItem={selected} filterLabel="Collection" setSelected={setSelected} />;
    $[1] = selected;
    $[2] = setSelected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(collection) {
  return {
    label: COLLECTED_COLLECTIONS_META[collection].label,
    value: collection,
    key: collection
  };
}